/**
 * Loading state shaped like the Parent access-code card it becomes.
 */
const LinkingPageSkeleton = () => (
  <div
    className="flex items-start justify-center pt-12 sm:pt-20 px-4 min-h-[60vh]"
    role="status"
    aria-label="Loading child linking"
  >
    <div
      className="card bg-base-100 rounded-3xl max-w-[400px] w-full border border-base-200/60"
      style={{ boxShadow: '0 4px 32px -4px rgba(0,0,0,0.08), 0 2px 8px -2px rgba(0,0,0,0.04)' }}
    >
      <div className="card-body p-8">
        <div className="h-6 w-44 skeleton mx-auto mb-1" />
        <div className="h-4 w-56 skeleton mx-auto" />
        <div className="flex justify-center gap-2.5 mt-4 mb-6">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="w-11 h-13 rounded-xl skeleton" />
          ))}
        </div>
        <div className="h-5 w-full skeleton mb-3" />
        <div className="h-5 w-48 skeleton mb-6" />
        <div className="h-12 w-full skeleton rounded-xl" />
      </div>
    </div>
  </div>
);

export default LinkingPageSkeleton;
